import { compose } from 'redux'
import { shareOnSocial } from '../../../../store/modules/social'
import View from './RedditShareButton'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const mapDispatchToProps = dispatch => ({
  shareOnSocial: compose(dispatch, shareOnSocial),
})

const RedditShareButton = connect(mapStateToProps, mapDispatchToProps)(View)

export default RedditShareButton
